import { RequestState } from './type'

export const state: RequestState = {
  request: [],
  sendRequest: [],
  approveRequest: []
};

export default state;